import { lazyComponent } from '@/utils/lazyComponent'

// 신규(Okta) 회원가입 완료 페이지 — /auth/okta-signup-complete
export default lazyComponent(() => import('./SignupComplete'))
